
















































































































































import { Component, Ref, Vue } from 'vue-property-decorator'
import SeletorDeRegimeFiscal from '@/components/fiscal/SeletorDeRegimeFiscal.vue'
import SeletorDeOrigem from '@/components/fiscal/SeletorDeOrigem.vue'
import CamposDeImposto from '@/views/application/configuracoes/fiscal/shareds/CamposDeImposto.vue'
import { obrigatorio } from '@/shareds/regras-de-form'
import { FindOrigemUseCase, FindRegraDeImpostoUseCase, SaveRegraDeImpostoUseCase } from '@/usecases'
import { CapaRegraImposto, NcmPorTransacao } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import SeletorDeNcm from '@/components/ui/SeletorDeNcm.vue'
import Confirmacao from '@/components/ui/Confirmacao.vue'

@Component({
	components: {
		SeletorDeRegimeFiscal,
		SeletorDeOrigem,
		CamposDeImposto,
		SeletorDeNcm,
		Confirmacao,
	},
})
export default class DialogoDeCapaDeRegraFiscal extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() descricaoDaRegra!: HTMLInputElement
	@Ref() confirmacaoExclusao!: Confirmacao

	obrigatorio = obrigatorio
	tipoDeTransacaoDeRegraFiscal = ['Venda', 'Devolução' ,'Transferência' ,'Consignado' ,'Demonstração' ,'Brinde' ,'Outros' ,'Conserto' ,'Ativo' ,'Consumo' ,'Uniforme' ,'Não Configuradas']
	tipoEntradaSaidaRegraFiscal = ['Entrada', 'Saída', 'Não Configuradas']

	regra: CapaRegraImposto | null = null
	saveRegraDeImpostoUseCase = new SaveRegraDeImpostoUseCase()
	findOrigemUsecase = new FindOrigemUseCase()
	findRegraDeImpostoUseCase = new FindRegraDeImpostoUseCase()
	findRegraImposto
	carregando = true
	salvando = false
	mostra = false
	reloadGrid = false
	dialogoNcm = false
	ncmEditado: NcmPorTransacao = {
		ncm: undefined,
		transacao: 'Não Configuradas',
		entradaSaida: 'Não Configuradas',
	}
	indiceEditado = -1
	editandoNcm = false

	headersNcmPorTransacao = [
		{ text: 'NCM', value: 'ncm.codigo' },
		{ text: 'Transação', value: 'transacao' },
		{ text: 'Entrada/Saída', value: 'entradaSaida' },
		{ text: 'Ações', value: 'actions', sortable: false },
	]

	get formTitle() {
		return this.indiceEditado === -1 ? 'Novo NCM' : 'Editar NCM'
	}

	mostrar(regra: CapaRegraImposto) {
		this.mostra = true
		this.regra = {
			...regra,
			ncmsPorTransacao: regra.ncmsPorTransacao ? [...regra.ncmsPorTransacao] : [],
		}

		setTimeout(() => {
			this.form.resetValidation()
			this.descricaoDaRegra.focus()
		})
	}

	esconder() {
		this.mostra = false
	}

	async salvar() {
		if (!this.regra) return
		try {
			this.salvando = true
			if (!this.regra.origem.id) throw new Error('Origem não possui id')
			this.regra = !this.regra.id
				? await this.saveRegraDeImpostoUseCase.create({
					...this.regra,
					origem: this.regra.origem.id,
				})
				: await this.saveRegraDeImpostoUseCase.updateCapa({
					...this.regra,
					origem: this.regra.origem.id,
				})
			AlertModule.setSuccess('Regra de Imposto salva com sucesso')
			this.$emit('salvar', this.regra)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	adicionarNcmPorTransacao() {
		if (!this.regra) return
		if (!this.regra.ncmsPorTransacao) {
			this.regra.ncmsPorTransacao = []
		}
		this.ncmEditado = {
			ncm: undefined,
			transacao: 'Não Configuradas',
			entradaSaida: 'Não Configuradas',
		}
		this.indiceEditado = -1
		this.dialogoNcm = true
	}

	editarNcmPorTransacao(item: NcmPorTransacao) {
		if (!this.regra || !this.regra.ncmsPorTransacao) return
		this.editandoNcm = true
		this.indiceEditado = this.regra.ncmsPorTransacao.indexOf(item)
		this.ncmEditado = Object.assign({}, item)
		this.dialogoNcm = true
	}

	excluirNcmPorTransacao(item: NcmPorTransacao) {
		if (!this.regra || !this.regra.ncmsPorTransacao || !this.confirmacaoExclusao) return
		const index = this.regra.ncmsPorTransacao.indexOf(item)

		console.log('index', index)
		if (index >= 0) {
			this.confirmacaoExclusao.mostrar().then(confirmado => {
				if (confirmado && this.regra && this.regra.ncmsPorTransacao) {
					this.regra.ncmsPorTransacao.splice(index, 1)

					this.reloadGrid = true
					setTimeout(() => {
						this.reloadGrid = false
					}, 1)
				}
			})
		}
	}

	fecharDialogoNcm() {
		this.dialogoNcm = false
		this.editandoNcm = false
		this.$nextTick(() => {
			this.ncmEditado = {
				ncm: undefined,
				transacao: 'Não Configuradas',
				entradaSaida: 'Não Configuradas',
			}
			this.indiceEditado = -1
		})
	}

	async salvarNcm() {
		if (!this.regra || !this.regra.ncmsPorTransacao) return
		if (!this.ncmEditado.ncm || !this.ncmEditado.ncm.id) return

		if (!this.editandoNcm && this.regra.id) {
			const jaCadastradoEmMemoria = !!this.regra.ncmsPorTransacao.find(ncmPorTransacao => ncmPorTransacao.ncm?.id === this.ncmEditado.ncm?.id)

			if (jaCadastradoEmMemoria) {
				AlertModule.setError('NCM já cadastrada para essa regra fiscal')
				return
			}

			const ncmId = this.ncmEditado.ncm.id
			const tipoTransacao = this.ncmEditado.transacao
			const entradaSaida = this.ncmEditado.entradaSaida
			const regime = this.regra.regimeFiscal

			const podeCadastrarRegraDeNcm = await this.findRegraDeImpostoUseCase.validarNovaRegraDeNcm(ncmId, tipoTransacao, entradaSaida, regime)

			if (!podeCadastrarRegraDeNcm) {
				AlertModule.setError('NCM já configurado para outra regra fiscal do mesmo regime com essa transação')
				return
			}
		}

		if (this.indiceEditado > -1) {
			this.$set(this.regra.ncmsPorTransacao, this.indiceEditado, { ...this.ncmEditado })
		} else {
			this.regra.ncmsPorTransacao.push({ ...this.ncmEditado })
		}

		this.reloadGrid = true
		setTimeout(() => {
			this.reloadGrid = false
		}, 1)

		this.fecharDialogoNcm()
	}
}
